let finishListeners = [];
let startListeners = [];

export function onFinishLoading(cb) {
    finishListeners.push(cb);
}
export function onStartLoading(cb) {
    startListeners.push(cb);
}

export function startLoading() {
    for (const l of startListeners) {
        l();
    }
    startListeners = [];
}
export function finishLoading() {
    for (const l of finishListeners) {
        l();
    }
    finishListeners = [];
}


// WEBPACK FOOTER //
// ./src/js/pebbleLoading.jsx